import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const options = [
  { value: 'light' as const, icon: Sun, label: 'Light' },
  { value: 'dark' as const, icon: Moon, label: 'Dark' },
  { value: 'system' as const, icon: Monitor, label: 'System' },
];

export default function ThemeToggle({ compact = false, darkSidebar = false }: { compact?: boolean; darkSidebar?: boolean }) {
  const { mode, setMode } = useTheme();

  if (compact) {
    const current = options.find(o => o.value === mode) ?? options[2];
    const next = mode === 'light' ? 'dark' : mode === 'dark' ? 'system' : 'light';
    return (
      <button
        onClick={() => setMode(next)}
        className="flex items-center justify-center w-9 h-9 rounded-lg transition-colors"
        style={darkSidebar ? { color: '#5A7D75' } : undefined}
        title={`Theme: ${current.label}`}
      >
        <current.icon className="w-5 h-5" />
      </button>
    );
  }

  if (darkSidebar) {
    return (
      <div className="flex items-center gap-1 p-1 rounded-lg" style={{ background: 'rgba(255,255,255,0.06)' }}>
        {options.map(({ value, icon: Icon, label }) => (
          <button
            key={value}
            onClick={() => setMode(value)}
            className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium transition-colors"
            style={{
              background: mode === value ? 'rgba(22,160,133,0.25)' : 'transparent',
              color: mode === value ? '#EDF4F2' : '#5A7D75',
            }}
            title={label}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden md:inline">{label}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 p-1 rounded-lg bg-muted">
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setMode(value)}
          className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium transition-colors ${
            mode === value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title={label}
        >
          <Icon className="w-3.5 h-3.5" />
          <span className="hidden md:inline">{label}</span>
        </button>
      ))}
    </div>
  );
}
